import { Address } from '../address';
import { Area } from '../area';
import { CenterDepartment } from '../center-department';
import { ServiceCenter } from '../service-center';
import { Specialite } from '../specialite';
import { Unavailability } from '../unavailability';
import { Vacation } from '../vacation';
import { CareSkill } from './care-skill';

export class Employee {
	readonly id: number;
	firstName: string;
	lastName: string;
	email: string;
	address: Address;
	workplaceAddress: Address;
	birthDate: string;
	phone: string;
	type: string;
	active: boolean;

	serviceCenter: ServiceCenter;
	//    area: Area;

	workingHoursPerWeek: number;
	maxWorkingHourDaily: number;
	autoAssignment: boolean;

	//    enumCompetence: string;
	careSkills: CareSkill[];
	specialties: Specialite[];

	vacations: Vacation[];
	unavailabilities: Unavailability[];

	areas: Area[];
	centerDepartments: CenterDepartment[];
	colorIndex: number;

	totalVacationDaysEntitled?: number;
	totalVacationDaysTaken?: number;

	constructor(
		options: {
			firstName?: string;
			lastName?: string;
			email?: string;
			address?: Address;
			birthDate?: string;
			phone?: string;
			type?: string;

			serviceCenter?: ServiceCenter;

			workingHoursPerWeek?: number;
			maxWorkingHourDaily?: number;
			autoAssignment?: boolean;

			careSkills?: CareSkill[];
			specialties?: Specialite[];

			vacations?: Vacation[];
			unavailabilities?: Unavailability[];
			areas?: Area[];
			centerDepartments?: CenterDepartment[];
			colorIndex?: number;
		} = {}
	) {
		this.firstName = options.firstName || null;
		this.lastName = options.lastName || null;
		this.email = options.email || null;
		this.address = options.address || new Address();
		//        this.address = options.address || null;
		this.birthDate = options.birthDate || null;
		this.phone = options.phone || null;
		this.type = options.type || 'EMP';

		this.serviceCenter = options.serviceCenter || null;

		this.workingHoursPerWeek = options.workingHoursPerWeek || null;
		this.maxWorkingHourDaily = options.maxWorkingHourDaily || null;
		this.autoAssignment = options.autoAssignment || true;

		//        this.careSkill = options.careSkill || 'LSF';
		this.careSkills = options.careSkills || [];
		this.specialties = options.specialties || [];

		this.vacations = options.vacations || [];
		this.unavailabilities = options.unavailabilities || [];
		this.areas = options.areas || null;
		this.centerDepartments = options.centerDepartments || null;
		this.colorIndex = options.colorIndex || -1;
	}
}
